import script from "./HomeProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeProgress.vue?vue&type=script&setup=true&lang=ts"

export default script